"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var UpdateRolesModal_module_css_1 = __importDefault(require("./UpdateRolesModal.module.css"));
var q_play_components_1 = require("@nordicscreen/q-play-components");
var ApiManager_1 = __importDefault(require("@/functions/ApiManager"));
var react_bootstrap_1 = require("react-bootstrap");
var UpdateRolesModal = function (_a) {
    var _b, _c;
    var modal = _a.modal, user = _a.user, refresh = _a.refresh, currentUser = _a.currentUser;
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var _d = (0, react_1.useState)({ message: "" }), errors = _d[0], setError = _d[1];
    var _e = (0, react_1.useState)(((_b = user.qteams) === null || _b === void 0 ? void 0 : _b.map(function (qteam) { return qteam.id; })) || []), qteams = _e[0], setQteams = _e[1];
    var _f = (0, react_1.useState)(((_c = user.qteams) === null || _c === void 0 ? void 0 : _c.map(function (qteam) { return qteam.id; })) || []), initialQteams = _f[0], setInitialQteams = _f[1];
    var _g = (0, react_1.useState)([]), globalQteams = _g[0], setGlobalQteams = _g[1];
    var _h = (0, react_1.useState)(false), isLoading = _h[0], setIsLoading = _h[1];
    (0, react_1.useEffect)(function () {
        var getQteams = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ApiManager_1.default.getQteams()];
                    case 1:
                        response = _a.sent();
                        setGlobalQteams(response);
                        return [2 /*return*/];
                }
            });
        }); };
        getQteams();
    }, []);
    (0, react_1.useEffect)(function () {
        setError({ message: "" });
        var teamIds = user.qteams ? user.qteams.map(function (team) { return team.id; }) : [];
        setQteams(teamIds);
        setInitialQteams(teamIds);
    }, [modal.isShown, user.qteams]);
    var handleUpdateQteams = function () {
        var currentUserId = user.id;
        var teamsToAdd = qteams.filter(function (id) { return !initialQteams.includes(id); });
        var teamsToRemove = initialQteams.filter(function (id) { return !qteams.includes(id); });
        teamsToAdd.forEach(function (teamId) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ApiManager_1.default.addUsersToQteam(teamId, [currentUserId])];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); });
        teamsToRemove.forEach(function (teamId) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ApiManager_1.default.removeUsersFromQteam(teamId, [currentUserId])];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); });
        refresh();
        modal.toggle();
    };
    var onSubmit = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var qteamId, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    e.preventDefault();
                    setIsLoading(true);
                    qteamId = user.qteams && user.qteams.length > 0 ? user.qteams[0].id : null;
                    if (!qteamId) {
                        setError({ message: t("No qteam associated with user") });
                        setIsLoading(false);
                        return [2 /*return*/];
                    }
                    setError({ message: null });
                    if (qteams.length === 0) {
                        setError({ message: t("Choose at least one team") });
                        setIsLoading(false);
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, handleUpdateQteams()];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    setError({ message: "Failed to update qteams" });
                    return [3 /*break*/, 4];
                case 4:
                    setIsLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var headline = t("Update user teams");
    var body = (react_1.default.createElement("div", { className: UpdateRolesModal_module_css_1.default.bodyClass },
        react_1.default.createElement("div", null,
            react_1.default.createElement("h3", { className: UpdateRolesModal_module_css_1.default.subtitle }, t("Update teams on a user")),
            react_1.default.createElement("div", { className: UpdateRolesModal_module_css_1.default.rolesContainer }, globalQteams === null || globalQteams === void 0 ? void 0 : globalQteams.map(function (qteam) {
                var isAdminTeam = qteam.roles.some(function (role) { return role.id === 3; });
                var hasAdminRole = qteams.includes(qteam.id) && isAdminTeam;
                var otherAdminTeamsSelected = qteams.filter(function (teamId) {
                    var team = globalQteams.find(function (q) { return q.id === teamId; });
                    return team && team.roles.some(function (role) { return role.id === 3; });
                }).filter(function (teamId) { return teamId !== qteam.id; }).length > 0;
                var isDisabled = hasAdminRole && !otherAdminTeamsSelected && user.id === currentUser;
                return (react_1.default.createElement("div", { key: qteam.id, className: "d-flex align-items-center justify-content-between ns-font-family ns-font-size-14 ".concat(UpdateRolesModal_module_css_1.default.roleRow, " ").concat(UpdateRolesModal_module_css_1.default.standardValues) },
                    react_1.default.createElement(react_bootstrap_1.Form.Check, { id: "qteam.".concat(qteam.id), className: UpdateRolesModal_module_css_1.default.checkboxContainer },
                        react_1.default.createElement(react_bootstrap_1.Form.Check.Label, { className: UpdateRolesModal_module_css_1.default.checkboxLabel }, qteam.name),
                        react_1.default.createElement(react_bootstrap_1.Form.Check.Input, { type: "checkbox", value: qteam.id, "data-cy": qteam.name, className: UpdateRolesModal_module_css_1.default.roleCheckbox, checked: qteams.includes(qteam.id), onChange: function (e) {
                                if (!isDisabled) {
                                    var updatedQteams = e.currentTarget.checked
                                        ? __spreadArray(__spreadArray([], qteams, true), [qteam.id], false) : qteams.filter(function (qteamId) { return qteamId !== qteam.id; });
                                    setQteams(updatedQteams);
                                }
                            }, disabled: isDisabled }))));
            })))));
    var footer = (react_1.default.createElement("div", { className: UpdateRolesModal_module_css_1.default.popUpButtonContainer, "data-cy": "Update" },
        errors.message ? react_1.default.createElement("span", { className: "text-danger m-2" }, errors.message) : null,
        isLoading && (react_1.default.createElement("div", { className: "d-flex align-items-center justify-content-center", style: { width: "125px", height: "70px" } },
            react_1.default.createElement(q_play_components_1.Spinner, null))) || react_1.default.createElement(q_play_components_1.Button, { onClick: onSubmit, text: t("Update") })));
    return (react_1.default.createElement(q_play_components_1.Modal, { isShown: modal.isShown, onClose: modal.toggle, headerText: headline, body: body, footer: footer, dialogClassName: UpdateRolesModal_module_css_1.default.customModal, centered: true }));
};
exports.default = UpdateRolesModal;
